module.exports = __webpack_public_path__ + "img/alert01.8de6b1af.png";